/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-06-30 18:01:19
 * @LastEditors: linxi
 * @LastEditTime: 2021-08-10 17:52:54
 */
import { unwrapResult } from "@reduxjs/toolkit";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../app/store";
import { CirclePieCharts } from "../../components/CirclePieCharts";
import { Skeleton } from "../HealthPrisonAnaylse/Skeleton";
import styles from "./WarningRulesAnaylse.module.css";
import { getWarningRuleAnaylseData } from "./WarningRulesAnaylseSilce";

/* 规则启用占比 */
export const EnableRulesProportion = () => {
  // const [time, setTime] = useState(1);

  const [enableData, setEnableData] = useState<any>([]);
  const dispatch = useDispatch<AppDispatch>();
  useEffect(() => {
    dispatch(getWarningRuleAnaylseData({ dType: 1 }))
      .then(unwrapResult)
      .then((res) => {
        setEnableData(
          res.map((v) => {
            return {
              name: v.provRuleName,
              value: v.total || undefined,
            };
          })
        );
      });
  }, [dispatch]);
  return (
    <div className={styles.EnableRules}>
      <div className={styles.rulesSelect}>
        <h3>预警规则启用占比分析</h3>
      </div>
      <div className={styles.rulesContent}>
        {enableData.length ? (
          <CirclePieCharts
            colorList={[
              "#304ffe",
              "#0395ff",
              "#40c4ff",
              "#448aff",
              "#82b1ff",
              "#00b0ff",
              "#6ab1ff",
              "#00e5ff",
              "#098adc",
              "#80d8ff",
              "#26c6da",
              "#039be5",
              "#29b6f6",
              "#0285ff",
              "#00acc1",
              "#15bcec",
              "#338eff",
              "#33ccff",
              "#49baf8",
              "#8ad7f6",
              "#33ffff",
              "#7ceee3",
              "#57e9c4",
              "#a7ffeb",
            ]}
            pieData={enableData}
            style={{ height: "100%" }}
          />
        ) : (
          <Skeleton infoMsg="此页面暂无数据" />
        )}
      </div>
    </div>
  );
};
